<template>
  <div class="container-fluid">
    <!-- <b-label class="d-block text-dark mb-2">Background</b-label>
    <b-list-group>
      <b-list-group-item variant="secondary" style="background-color:#eee !important">
        <div class="form-check">

          <input class="form-check-input" type="checkbox" id="mainCheckbox1" v-model="isImageVisible">
          <label class="form-check-label" for="mainCheckbox1">
              Main Image
          </label>
          </div>
      </b-list-group-item>
    </b-list-group> -->
    <b-label class="d-block text-dark my-2 mt-3">Drawings</b-label>
    <b-list-group>
      <b-list-group-item variant="secondary" style="background-color:#eee !important">
        <div class="form-check">

          <input class="form-check-input" type="checkbox" id="sectionVisibility" v-model="showRoofSections" @click="toggleRoofSection()">
          <label class="form-check-label" for="sectionVisibility">
              Roof sections
          </label>
          </div>
      </b-list-group-item>
      <b-list-group-item variant="secondary" style="background-color:#eee !important">
        <div class="form-check">

          <input class="form-check-input" type="checkbox" id="equipmentVisibility" v-model="showEquipments" @click="toggleEquipments()">
          <label class="form-check-label" for="equipmentVisibility">
              Equipments
          </label>
          </div>
      </b-list-group-item>
    </b-list-group>

    <b-label class="d-block text-dark my-2 mt-3">Notes</b-label>
    <b-list-group>
      <b-list-group-item variant="secondary" style="background-color:#eee !important">
        <div class="form-check">

          <input class="form-check-input" type="checkbox" id="equipmentVisibility" v-model="showNotes" @click="toggleNotes()">
          <label class="form-check-label" for="equipmentVisibility">
              Notes
          </label>
          </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      visibleSectionIds: [],
      isImageVisible: true,
      showRoofSections: true,
      showEquipments: true,
      showNotes: true,
    }
  },

  mounted() {
    if(this.isPDFProject){
      this.visibleSectionIds = this.sections.map(sh => sh.id)
    } else{
      this.visibleSectionIds = this.allShapes.filter(sh => sh.map).map(sh => sh.id)
    }
  },

  computed: {
    ...mapGetters({
        projectSidebar: "ui/projectSidebar",
        sections: 'sections/items',
        allShapes: 'gmap/allShapes',
        map: 'gmap/map',
        notes: 'notes/items'
        
    }),

    groups:{
        get(){
            return this.$store.getters['canvas/groups']
        },
        set(value){
            this.$store.commit('canvas/groups', value)
        }
    },

    roofSections: function(){
      return this.sections.filter(s => s.section_type == 'roof').map(roof=>{
        roof.equip_count = this.sections.filter((s)=>{
          return s.equipment_detail && s.equipment_detail.roof_section_id == roof.id
        }).length
        return roof
      })
    },

    equipmentSections: function() {
      return this.sections.filter(s => s.section_type == 'equipment').map(equipment => {
        equipment.equip_count = this.sections.filter((s) => {
          return s.equipment_detail && s.equipment_detail.equipment_id == equipment.id;
        }).length;
        return equipment;
      });
    },

    // equipmentSections: function(){
    //   return this.sections.filter(s => s.section_type == 'equipment')
    // },

    isPDFProject(){
      return this.$route.name == 'project-pdf'
    }
  },

  watch: {
    allShapes(val1, val2){
      this.visibleSectionIds = this.allShapes.filter(sh => sh.map).map(sh => `${sh.id}`)
    },

    isImageVisible(visible){
      console.log("main image visible:  ", visible)
      this.$eventbus.$emit('raster-visibility-changed', visible)
    },

    visibleSectionIds(val1, val2){
      if(this.isPDFProject){
        console.log("groups", this.groups)
        this.sections.map(section=>{
          try{
          this.groups[section.id].obj.visible = true
          if(!this.visibleSectionIds.includes(section.id)){
            this.groups[section.id].obj.visible = false
          }}catch(err){
            console.log(err)
          }
        })
      } else {
        this.allShapes.forEach( sh => {
          if(!(val1.includes(sh.id))){
            sh.setMap(null)
            if(sh.centerMarker){
              sh.centerMarker.setMap(null)
            }
          } else {
            sh.setMap(this.map)
            if(sh.centerMarker){
              sh.centerMarker.setMap(this.map)
            }
          }
        })
      }
    }
  },

  methods: {
    toggleRoofSection(){
      let roofSectionIds = this.sections.filter(section => section.section_type === 'roof').map(section => section.id);

      if (this.showRoofSections) {
        this.visibleSectionIds = this.visibleSectionIds.filter(
          id => !roofSectionIds.includes(id)
        );
      } else {
        this.visibleSectionIds = Array.from(new Set([...this.visibleSectionIds, ...roofSectionIds]));
      }

      this.showRoofSections = !this.showRoofSections
    },

    toggleNotes(){
      this.$eventbus.$emit('toggle-note-visiblity', !this.showNotes);
    },

    toggleEquipments(){
      let equipmentIds = this.sections
        .filter(section => section.section_type === 'equipment')
        .map(section => section.id);

      if (this.showEquipments) {
        this.visibleSectionIds = this.visibleSectionIds.filter(
          id => !equipmentIds.includes(id)
        );
      } else {
        this.visibleSectionIds = Array.from(new Set([...this.visibleSectionIds, ...equipmentIds]));
      }
      this.showEquipments = !this.showEquipments
    },
  }
  
}
</script>
